import i18next from 'i18next';
import i18n from './i18n/index.js';

const translator = i18next.createInstance();
translator.init({
  resources: i18n,
  nsSeparator: '::',
  keySeparator: ' ##### ',
  fallbackLng: 'kr',
});

export { translator };
